export default __webpack_public_path__ + "static/media/p2.1026cfb3.jpg";